import React from 'react';
import { Paper, Box } from '@material-ui/core';
import { DataTable } from 'src/components';

const TransViewTable = ({ transDetails, settings, source }) => {
  const items = transDetails?.[source]?.items || [];
  return (
    <>
      <Paper component={Box} p={1}>
        <DataTable columns={settings} data={items} />
      </Paper>
    </>
  );
};

export default TransViewTable;
